module.exports = __webpack_public_path__ + "img/cm.576b4e70.svg";